
import { OPERATIONAL_AI_INSIGHTS } from "../Reducers/operationalAiInsightsReducer";
import { EnterpriseAiInsightsList } from "../Model/AiInsightObjects";
import { fetchOperationalAiInsights } from "../Util/queries";

export const getOperationalAiInsights = () => async (dispatch) => {
    try {
        const response = await fetchOperationalAiInsights();
        dispatch({
            type: OPERATIONAL_AI_INSIGHTS,
            payload: new EnterpriseAiInsightsList(response.data, "n/a")
        });
    } catch (error) {
        console.error(error);
        dispatch({
            type: OPERATIONAL_AI_INSIGHTS,
            payload: new EnterpriseAiInsightsList(null, "n/a")
        });  
    }
}
